import React from 'react';

import { twMerge } from 'tailwind-merge';

import { getRelativeTimeAgo } from '../../../../helpers/date';
import { getUserUrl } from '../../../../helpers/urls';
import { Avatar, AvatarSize } from '../../../Avatar/Avatar';
import { InternalLink } from '../../../Clickables/InternalLink/InternalLink';
import { Heading } from '../../../Heading/Heading';
import { Text } from '../../../Text/Text';

interface UserInformationProps {
  avatarUrl: string;
  className?: string;
  informationDate?: Date;
  informationDetails: string[];
  informationSeparator?: string;
  nickname: string;
  userUrl?: string;
}

export const UserInformation = ({
  avatarUrl,
  className,
  informationDate,
  informationDetails,
  informationSeparator,
  nickname,
  userUrl,
}: UserInformationProps) => {
  const timePassageAbbreviation = informationDate
    ? getRelativeTimeAgo(informationDate)
    : informationDate;
  const informationContent = [timePassageAbbreviation, ...informationDetails]
    .filter(Boolean)
    .join(informationSeparator);

  return (
    <div className={twMerge('flex', className)}>
      <InternalLink
        aria-label={`Navigate to angler profile of ${nickname}`}
        variant="buttonNone"
        to={userUrl ?? getUserUrl(nickname)}
        size="none"
        className="mr-3"
      >
        <div style={{ minWidth: 48 }}>
          <Avatar size={AvatarSize.SMALL} src={avatarUrl} alt={`${nickname}'s avatar`} />
        </div>
      </InternalLink>
      <section className="h-inherit my-auto flex flex-col">
        <InternalLink variant="textPrimary" to={userUrl ?? getUserUrl(nickname)}>
          <Heading as="h5" className="w-full" variant="3xs">
            {nickname}
          </Heading>
        </InternalLink>

        <Text className="mb-0 mt-1 text-trench" variant="sm">
          {informationContent}
        </Text>
      </section>
    </div>
  );
};
